import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import documents from './modules/documents'
import extensions from './modules/extensions'
import help from './modules/help'
import navigation from './modules/navigation'
import organizations from './modules/organizations'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    documents,
    extensions,
    help,
    navigation,
    organizations,
    user
  },
  strict: process.env.NODE_ENV !== 'production'
})

Vue.prototype.$notify = function (message) {
  store.commit('notify', message)
}

Vue.prototype.$notifyError = function (message, error) {
  store.commit('notifyError', { message, error })
}

// `what` arg is a boolean or a string <page name>:<type>
// eg: EAC:glossary
Vue.prototype.$openHelpMenu = function (what) {
  store.commit('help/showContextualHelp', what)
}

Object.defineProperties(Vue.prototype, {
  $currentUser: {
    get () {
      return store.getters['user/currentUser']
    }
  },
  $currentOrganization: {
    get () {
      return store.getters['organizations/currentOrganization']
    }
  }
})

export default store
